module.exports = __webpack_public_path__ + "static/media/demo.7e270909.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/demo.webp
// module id = 559
// module chunks = 4